import { useEffect, useState } from 'react';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { appActions } from '@nxsys/store/slices/app/reducer/appSlice';
import { socketYearEndProcess } from '@nxsys/services/sockets';
import ModalKickOff from './ModalKickOff';

const YearEndAlert = () => {
  const dispatch = useDispatch();
  const { user, appConfigs, currentYearEndProcess } = useSelector(
    (state: AppState) => state.appStore,
  );

  const [openKickOffModal, setOpenKickOffModal] = useState(false);
  const [lastYearEndStatus, setLastYearEndStatus] = useState<string | null>(
    null,
  );

  const displayAlert =
    appConfigs?.taxCalendar?.displayYearEndProcessAlert;
  const processedYearEnd = appConfigs?.taxCalendar?.processedYearEnd;
  const lastYearEndProcessTaxYear =
    appConfigs?.taxCalendar?.lastYearEndProcessTaxYear;
  const taxYear = appConfigs?.taxCalendar?.taxYear;

  useEffect(() => {
    setLastYearEndStatus(
      appConfigs?.taxCalendar?.lastYearEndProcessStatus ?? null,
    );
  }, [appConfigs]);

  useEffect(() => {
    const channel = `year-end-process-${user?.companyParentId}`;
    const handler = (res: any) => {
      if (res?.data?.status === 'COMPLETED') {
        setLastYearEndStatus('COMPLETED');
      }
    };
    socketYearEndProcess.on(channel, handler);
    return () => {
      socketYearEndProcess.off(channel, handler);
    };
  }, [user?.companyParentId]);

  const handleYearEndClick = () => {
    (dispatch as any)(appActions.getCurrentYearEndProcess())
      .unwrap()
      .then(() => setOpenKickOffModal(true))
      .catch((err: any) => {
        const msg =
          err?.response?.data?.message || err?.message || 'Something went wrong';
        message.error(msg);
      });
  };

  if (!displayAlert) return null;

  const isCompleted = lastYearEndStatus === 'COMPLETED';

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          color: isCompleted ? '#00795B' : '#FF9F43',
          cursor: 'pointer',
          fontSize: '0.9rem',
          padding: '8px 0',
        }}
        onClick={handleYearEndClick}
      >
        {processedYearEnd ? (
          <>
            Year End process completed for Tax Year{' '}
            {lastYearEndProcessTaxYear ?? taxYear}-
            {(lastYearEndProcessTaxYear ?? taxYear ?? 0) + 1}.&nbsp;
            <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
              View Summary
            </span>
          </>
        ) : (
          <>
            Payroll Year-End processing for {taxYear}-
            {(taxYear ?? 0) + 1} is&nbsp;
            <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
              Now Ready!
            </span>
          </>
        )}
      </div>
      {openKickOffModal && (
        <ModalKickOff
          open={openKickOffModal}
          onClose={() => setOpenKickOffModal(false)}
          yearEndData={currentYearEndProcess as any}
          taxYear={lastYearEndProcessTaxYear ?? taxYear ?? 0}
        />
      )}
    </>
  );
};

export default YearEndAlert;
